export const islandTypes = [
  { id: 1, name: "Ρόδος" },
  { id: 2, name: "Κως" },
  { id: 3, name: "Κάλυμνος" },
  { id: 4, name: "Λέρος" },
  { id: 5, name: "Κάρπαθος" },
  { id: 6, name: "Κάσος" },
  { id: 7, name: "Πάτμος" },
  { id: 8, name: "Αστυπάλαια" },
  { id: 9, name: "Νίσυρος" },
  { id: 10, name: "Τήλος" },
  { id: 11, name: "Σύμη" },
  { id: 12, name: "Χάλκη" },
  { id: 13, name: "Λειψοί" },
  { id: 14, name: "Μεγίστη" },
  { id: 15, name: "Αγαθονήσι" },
  { id: 16, name: "Σύρος" },
];

export const accidentTypes = [
  { id: 1, name: "Σύγκρουση σε προπορευόμενο όχημα" },
  { id: 2, name: "Μετωπική σύγκρουση" },
  { id: 3, name: "Πλαγιομετωπική σύγκρουση" },
  { id: 4, name: "Πλάγια σύγκρουση" },
  { id: 5, name: "Πρόσκρουση σε σταθμευμένο όχημα" },
  { id: 6, name: "Εκτροπή οχήματος" },
  { id: 7, name: "Ανατροπή οχήματος" },
  { id: 8, name: "Παράσυρση πεζού" },
  { id: 9, name: "Σύγκρουση με ζώο" },
  { id: 10, name: "Άλλο" },
];

export const severityVals = [
  { id: 1, name: "Χαμηλή" },
  { id: 2, name: "Μέτρια" },
  { id: 3, name: "Υψηλή" },
];

export const weatherVals = [
  { id: 1, name: "Χωρίς ιδιαίτερες καιρικές συνθήκες" },
  { id: 2, name: "Βροχή" },
  { id: 3, name: "Καταιγίδα" },
  { id: 4, name: "Χαλάζι" },
  { id: 5, name: "Χιονόπτωση" },
  { id: 6, name: "Ομίχλη" },
  { id: 7, name: "Άλλο" },
];

export const roadStatusVals = [
  { id: 1, name: "Στεγνό" },
  { id: 2, name: "Υγρό" },
  { id: 3, name: "Λάδια" },
  { id: 4, name: "Χαλίκι" },
  { id: 5, name: "Πάγος" },
  { id: 6, name: "Γλίτσα" },
  { id: 7, name: "Άλλο" },
];

export const vehicleTypes = [
  { id: 1, name: "Βαρέα οχήματα & Επαγγελματικά οχήματα > 3,5 τ " },
  { id: 2, name: "Δίκυκλα" },
  { id: 3, name: "Ενοικιαζόμενα" },
  { id: 4, name: "Επαγγελματικά επιβατικά & Επαγγελματικά οχήματα < 3,5 τ " },
  { id: 5, name: "Ποδήλατα" },
  { id: 6, name: "Πεζοί" },
  { id: 7, name: "Ηλεκτρικά πατίνια" },
  { id: 8, name: "Επιβατικό Ι.Χ." },
  { id: 9, name: "Λοιπά οχήματα" },
];

export const violationLabels = [
  { id: 1, name: "Διαπιστωμένη υπέρβαση του ορίου ταχύτητας" },
  { id: 2, name: "Αριστερή στροφή σε διπλή διαχωριστική γραμμή" },
  { id: 3, name: "Παραβίαση STOP/Φωτ. σηματοδότη" },
  { id: 4, name: "Παράνομη στάθμευση" },
  { id: 5, name: "Αντικανονικό προσπέρασμα" },
  { id: 6, name: "Επικίνδυνοι ελιγμοί" },
  { id: 7, name: "Παραβίαση προτεραιότητας σε κόμβο" },
  { id: 10, name: "Οδήγηση χωρίς τη νόμιμη άδεια οδήγησης" },
  { id: 9, name: "Οδήγηση υπό την επίδραση αλκοόλ" },
  { id: 8, name: "Παράνομη αναστροφή" },
];

export const injuredTypes = [
  { id: 1, name: "Ελαφρά τραυματίες" },
  { id: 2, name: "Βαριά τραυματίες" },
  { id: 3, name: "Νεκροί" },
];

export const getAccidentOptionLabel = (list, id) => {
  if (id === null || id === undefined || id === "") {
    return "";
  }

  const normalizedId = typeof id === "string" ? Number(id) : id;
  const match = list.find((item) => item.id === normalizedId);

  return match ? match.name : id;
};
